import styled from 'styled-components';

export const SearchForm = styled.form`
    display: flex;
    align-items: center;
`;